import { render } from "./original_multiple_upload.vue?vue&type=template&id=5b60e31c"
import script from "./original_multiple_upload.vue?vue&type=script&lang=js"
export * from "./original_multiple_upload.vue?vue&type=script&lang=js"

import "./original_multiple_upload.vue?vue&type=style&index=0&id=5b60e31c&lang=css"

import exportComponent from "E:\\devops.aliyun\\liangting\\liangting_business_web\\seller.web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__